// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeFile --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';

import type {
  Exact,
  OpenapiFilePurposeEnum,
} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment StripeFileFragment on OpenapiFile {
    created
    dashboard_url
    filename
    id
    purpose
    size
    title
    type
    url
  }
`;

export const stripeFileFragment: StripeFileFragmentDocument = doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeFileFragmentData = {
  readonly __typename: 'OpenapiFile';
  readonly created: number;
  readonly dashboard_url: string | null;
  readonly filename: string | null;
  readonly id: string;
  readonly purpose: OpenapiFilePurposeEnum;
  readonly size: number;
  readonly title: string | null;
  readonly type: string | null;
  readonly url: string | null;
};

export type StripeFileFragmentVariables = Exact<{[key: string]: never}>;

const stripeFileFragmentPermissions = {} as const;

doc.permissions = stripeFileFragmentPermissions;

export type StripeFileFragmentPermissions = V1PermissionToken<
  typeof stripeFileFragmentPermissions
>;

export type StripeFileFragmentDocument = GraphQlDocument<
  StripeFileFragmentData,
  StripeFileFragmentVariables,
  StripeFileFragmentPermissions
>;
